var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("free-activity-quantity-dialog", {
    attrs: {
      visible: _vm.visible,
      "current-state": _vm.currentState,
      submitting: _vm.submitting,
      "error-message": _vm.errorMessage,
      title: "免费活动分次核销",
      "quantity-label": "本次核销人数",
    },
    on: {
      confirm: function ($event) {
        return _vm.$emit("confirm", $event)
      },
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }